// Registers the service worker (public/sw.js, docs/pwa.md) once the page has loaded, in production builds only.
//
// Kill switch: set SERVICE_WORKER_ENABLED to false and deploy: every visitor's worker is unregistered on their next page
// load and none is registered again. If the app itself can't load, replace public/sw.js's body with
// SELF_UNREGISTER_SNIPPET (below) and deploy: the browser picks the new worker up on the next page load and it removes
// itself and its caches.

export const SERVICE_WORKER_URL = '/sw.js';
export const SERVICE_WORKER_ENABLED = true;

export const SELF_UNREGISTER_SNIPPET = `self.addEventListener('install', () => self.skipWaiting())
self.addEventListener('activate', (event) => event.waitUntil((async () => {
  for (const key of await caches.keys()) await caches.delete(key)
  await self.registration.unregister()
})()))`;

export const installServiceWorker = (win = window, enabled = SERVICE_WORKER_ENABLED && import.meta.env.PROD) => {
  const container = win.navigator.serviceWorker;
  if (!container) return;
  if (!enabled) {
    container
      .getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch(() => undefined);
    return;
  }
  // After `load`: the worker's own download never competes with the page's first files.
  const register = () => {
    container.register(SERVICE_WORKER_URL, { scope: '/' }).catch(() => undefined);
  };
  if (win.document.readyState === 'complete') register();
  else win.addEventListener('load', register, { once: true });
};
